import React, { useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';

import MobileSectionHeader from 'components/Layout/MobileShell/MobileSectionHeader';
import MoreSheet from 'components/Layout/MobileShell/MoreSheet';
import useIsMobile from 'utils/hooks/useIsMobile';
import {
  videoProductToModuleName,
  videoProductToPageTitle,
  videoProductToParentRoute,
  videoRouteToProduct,
} from 'helper/videos';

// Wrapper de layout das rotas de vídeo (Meteorologia / Tutorial / Flux).
// No mobile renderiza o MobileSectionHeader (voltar + título da seção) espelhando
// o AgroLayout; no desktop é transparente (as views já trazem seu próprio header).
export default function VideosLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [moreOpen, setMoreOpen] = useState(false);

  if (!isMobile) {
    return <Outlet />;
  }

  const product = videoRouteToProduct(location.pathname);

  if (product === undefined) {
    return <Outlet />;
  }

  // Página de detalhe (player) termina em /:id numérico (a listagem é /categories/:id).
  // Ela renderiza seu próprio header mobile (voltar → categoria), então o layout se omite.
  const isDetail = /\/\d+$/.test(location.pathname)
    && !location.pathname.includes('/categories');

  if (isDetail) {
    return <Outlet />;
  }

  return (
    <>
      <MobileSectionHeader
        backLabel={videoProductToPageTitle[product]}
        title={videoProductToModuleName[product]}
        onBack={() => navigate(videoProductToParentRoute[product])}
        onAvatarClick={() => setMoreOpen(true)}
      />
      <Outlet />
      <MoreSheet open={moreOpen} dismiss={() => setMoreOpen(false)} />
    </>
  );
}
